// localStorage „paměť velikosti per agenda" — jak velká má být agenda po osamostatnění.
// NE pozice, jen velikost (+ zda byla maximalizovaná). Ukládá se na reálné uživatelské gesto
// (konec resize / max-restore); čte se při RUČNÍM osamostatnění (detach). Reload má přednost
// kotvu (hash) — ta aplikuje rect programově a sem nezapisuje.
//
// Klíč = identita agendy: legacy → formGlobalName (všechny instance téhož formu sdílí velikost),
// native → agendaId. Vzor sdílený se splitterem (`nav:splitter:<id>` v PhoenixDesktop).

import type { LayerDescriptor } from '@/shared/navigation/core';

const PREFIX = 'phx:winsize:';

export interface WindowSizeMemory {
  readonly w: number;
  readonly h: number;
  readonly maximized?: boolean;
}

/** Stabilní klíč identity agendy: legacy = formGlobalName, native = agendaId. */
export function agendaSizeKey(layer: LayerDescriptor): string {
  const form = layer.openParams['formGlobalName'];
  const id = typeof form === 'string' && form.length > 0 ? `legacy:${form}` : layer.agendaId;
  return `${PREFIX}${id}`;
}

export function readWindowSizeMemory(layer: LayerDescriptor): WindowSizeMemory | null {
  try {
    const raw = localStorage.getItem(agendaSizeKey(layer));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<WindowSizeMemory>;
    if (typeof parsed.w !== 'number' || typeof parsed.h !== 'number') return null;
    return { w: parsed.w, h: parsed.h, maximized: parsed.maximized === true };
  } catch {
    return null;
  }
}

export function writeWindowSizeMemory(layer: LayerDescriptor, size: WindowSizeMemory): void {
  try {
    localStorage.setItem(
      agendaSizeKey(layer),
      JSON.stringify({
        w: Math.round(size.w),
        h: Math.round(size.h),
        maximized: size.maximized === true,
      })
    );
  } catch {
    /* localStorage nedostupné — ignorujeme */
  }
}
